import React from 'react'
import PropTypes from 'prop-types'
import { Paper, Stack, Typography, FormLabel, Box } from '@mui/material'
import { CommonButton } from '@/components/common'
import { OperationStatusChip } from '@/components/common/OperationStatusChip'
import { formatIsoDateWithWeekday } from '@/utils/date'

export const PastDriveCard = ({ item = {}, onViewResults, onViewDonors }) => {
  const {
    name,
    date,
    hours,
    address,
    total_registered_donors,
    total_units_collected,
    operation_status_name: operationStatusName,
    operation_status_chip_color: operationStatusChipColor,
  } = item

  const displayDate = date ? formatIsoDateWithWeekday(date) : null

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) auto' },
        alignItems: 'stretch',
        gap: { xs: 2, md: 3 },
        p: 2.5,
        width: '100%',
        borderRadius: '6px',
        backgroundColor: 'grey.100',
      }}
    >
      <Stack
        spacing={1.25}
        sx={{
          minWidth: { md: 0 },
          justifyContent: 'space-evenly',
          pr: { md: 1 },
        }}
      >
        {name && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              flexWrap: 'wrap',
            }}
          >
            <Typography variant='h6' fontWeight={600} color='text.primary'>
              {name}
            </Typography>
            {operationStatusName ? (
              <OperationStatusChip
                label={operationStatusName}
                chipColor={operationStatusChipColor}
              />
            ) : null}
          </Box>
        )}

        {displayDate && (
          <Typography variant='subtitle1'>
            <FormLabel
              component='span'
              sx={{ display: { xs: 'none', md: 'inline' } }}
            >
              Date:
            </FormLabel>{' '}
            {displayDate}
          </Typography>
        )}

        <Stack spacing={0.75}>
          {hours && (
            <Typography variant='body1'>
              <FormLabel
                component='span'
                sx={{ display: { xs: 'none', md: 'inline' } }}
              >
                Hours:
              </FormLabel>{' '}
              {hours}
            </Typography>
          )}
          {address && (
            <Typography variant='body1'>
              <FormLabel
                component='span'
                sx={{ display: { xs: 'none', md: 'inline' } }}
              >
                Address:
              </FormLabel>{' '}
              {address}
            </Typography>
          )}
        </Stack>

        <Stack spacing={0.75}>
          <Typography variant='body1'>
            <FormLabel component='span'>Total Donors:</FormLabel>{' '}
            {total_registered_donors ?? 0}
          </Typography>
          <Typography variant='body1'>
            <FormLabel component='span'>Units Collected:</FormLabel>{' '}
            {total_units_collected ?? 0}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        spacing={1}
        alignItems='flex-end'
        justifyContent='center'
        sx={{ minWidth: 140, flexShrink: 0, alignSelf: 'center' }}
      >
        {onViewDonors ? (
          <CommonButton
            width='140px'
            variant='secondary'
            onClick={onViewDonors}
          >
            Donors
          </CommonButton>
        ) : null}
        <CommonButton width='140px' variant='secondary' onClick={onViewResults}>
          View Results
        </CommonButton>
      </Stack>
    </Paper>
  )
}

PastDriveCard.propTypes = {
  item: PropTypes.object,
  onViewResults: PropTypes.func,
  onViewDonors: PropTypes.func,
}
